import React from 'react';
import { GenericListPage } from '../../../components/generic';
import { useTaskTypes, TaskType } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<TaskType>
      useData={useTaskTypes}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;

